import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import MovilMenu from '../MovilMenu/MovilMenu';
import Search from '../Search/Search';
import UserOptionsHeader from '../UserOptionsHeader/UserOptionsHeader';

import classes from './MainHeader.module.css';

const url = window.location.pathname.split('/');

const Header = () => {
  return (
    <AppBar position="static">
      <Toolbar className={classes.header}>
        <MovilMenu />
        {url[2] !== 'course' && <Search />}
        {url[2] !== 'a' && url[2] !== 'course' && (
          <UserOptionsHeader />
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
